"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HeaderMenuCategory = _interopRequireDefault(require("../HeaderMenuCategory"));
var _WriteUsPopup = _interopRequireDefault(require("./WriteUsPopup"));
var HeaderMenuFeedback = function HeaderMenuFeedback(props) {
  var showPopup = props.showPopup,
    onOpenModal = props.onOpenModal,
    onCloseModal = props.onCloseModal,
    isCompact = props.isCompact,
    breakpoint = props.breakpoint,
    isMobile = props.isMobile,
    isHomepage = props.isHomepage,
    className = props.className;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(CategoryPhone, {
    name: "\u041D\u0430\u043F\u0438\u0448\u0438\u0442\u0435 \u043D\u0430\u043C",
    slug: "phone",
    isCompact: isCompact,
    onClick: onOpenModal,
    breakpoint: breakpoint,
    isHomepage: isHomepage,
    className: className
  }), /*#__PURE__*/_react["default"].createElement(_WriteUsPopup["default"], {
    showPopup: showPopup,
    onCloseModal: onCloseModal,
    isMobile: isMobile
  }));
};
var CategoryPhone = (0, _styledComponents["default"])(_HeaderMenuCategory["default"]).withConfig({
  displayName: "HeaderMenuFeedback__CategoryPhone",
  componentId: "sc-4yhfvo-0"
})(["cursor:pointer;"]);
var _default = exports["default"] = HeaderMenuFeedback;